export const moLead: Record<string, string> = {
  'moLead.notAllowed': 'Trang này chỉ dành cho MO Lead.',
  'moLead.tabAdUnits': 'Ad Units',
  'moLead.tabMediationGroups': 'Mediation Groups',
  'moLead.tabByDate': 'Theo ngày',
  'moLead.tabByCountry': 'Theo quốc gia',
  'moLead.tabSetup': 'Cài đặt',
  'moLead.lastMonth': 'Tháng trước',
  'moLead.matchReq': 'Khớp yêu cầu',
  // Dùng chung làm thông báo "đã lưu" cho cả nút Đồng bộ (Ad Units) và Lưu (Setup).
  'moLead.syncDone': 'Đã lưu',
  'moLead.mg.searchPlaceholder': 'Tìm mediation group…',
  'moLead.mg.nameCol': 'Tên',
  'moLead.mg.lineCol': 'Line',
  'moLead.mg.rangeClamped': 'Tab Mediation Groups chỉ hiển thị {n} ngày gần nhất trong khoảng đã chọn (giới hạn).',
  'moLead.mg.variantA': 'Biến thể A',
  'moLead.mg.variantB': 'Biến thể B',
  'moLead.mg.variantSingle': 'Không gắn biến thể',
  'moLead.setup.pickOne': 'Chọn ít nhất 1 app',
  'moLead.setup.hint': 'Chọn app RoosterX cho các tab Ad Units, Mediation Groups, Theo ngày và Theo quốc gia. Tick đủ mọi app = hiển thị tất cả, kể cả app mới xuất hiện sau này.',
  'moLead.setup.selectNone': 'Bỏ chọn tất cả',
  'moLead.byDate.dateCol': 'Ngày',
  'moLead.byDate.sortDate': 'Ngày',
  'moLead.byDate.rangeClamped': 'Tab Theo ngày chỉ hiển thị {n} ngày gần nhất trong khoảng đã chọn (giới hạn).',
  'moLead.byCountry.countryCol': 'Quốc gia',
  'moLead.byCountry.shareCol': 'Tỉ trọng',
  'moLead.byCountry.searchPlaceholder': 'Tìm quốc gia…',
  'moLead.byDate.source': 'Nguồn: dữ liệu AdMob đồng bộ lúc 08:00 hằng ngày (ngày gần nhất có thể chưa đủ) · cập nhật lần cuối {t}',
  'moLead.byCountry.source': 'Nguồn: báo cáo AdMob trực tiếp, làm mới mỗi 15 phút — tổng có thể cao hơn tab Theo ngày ở ngày gần nhất.',
  'moLead.byCountry.rangeClamped': 'Tab Theo quốc gia chỉ hiển thị {n} ngày gần nhất trong khoảng đã chọn (giới hạn).',
  'moLead.byCountry.truncatedWarning': 'Báo cáo AdMob bị cắt bớt (vượt giới hạn 100.000 dòng) — số liệu Theo quốc gia có thể thấp hơn thực tế.',
  'moLead.adUnitDrill.adUnitCol': 'Ad unit',
  'moLead.adUnitDrill.truncated': 'Báo cáo ad unit trực tiếp bị cắt bớt (vượt giới hạn 100.000 dòng) — số liệu bên dưới có thể thấp hơn thực tế.',
  'moLead.adUnitDrill.liveReportNote': 'Số liệu ad unit lấy từ một báo cáo AdMob trực tiếp riêng, có thể lệch nhẹ so với dòng quốc gia; nếu mở sau khi cache 15 phút làm mới, số liệu có thể mới hơn dòng quốc gia.',
};
